module.exports = __webpack_public_path__ + "static/media/predictor-logo.8d2cd6c7.png";